const initialState = {
    data: null,
};
export const getDeletedByMeReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GETDELETEDDOCUMENT_SUCCESS':
            return {
                ...state,
                data: action.payload,
            };
        case 'GETDELETEDDOCUMENT_FAILURE':
            return {
                ...state,
                error: action.payload
            };
        default:
            return state;
    }
}

export default getDeletedByMeReducer;